import { render, staticRenderFns } from "./PurchaseConfirmationView.vue?vue&type=template&id=72630007&"
import script from "./PurchaseConfirmationView.vue?vue&type=script&lang=ts&"
export * from "./PurchaseConfirmationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports